module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av455-ac324a00be902c9ed8613232a977688a.jpg";